var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMultiStyleCloseIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3259 0.674083C18.7491 0.0972522 17.8139 0.0972521 17.237 0.674083L10 7.91112L2.76297 0.674082C2.18614 0.0972514 1.25091 0.0972524 0.674083 0.674083C0.0972524 1.25091 0.0972523 2.18614 0.674083 2.76297L7.91112 10L0.674082 17.237C0.0972514 17.8139 0.0972523 18.7491 0.674083 19.3259C1.25091 19.9028 2.18614 19.9028 2.76297 19.3259L10 12.0889L17.237 19.3259C17.8139 19.9028 18.7491 19.9028 19.3259 19.3259C19.9028 18.7491 19.9028 17.8139 19.3259 17.237L12.0889 10L19.3259 2.76297C19.9028 2.18614 19.9028 1.25091 19.3259 0.674083Z",
    fill: "#F05A5A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMultiStyleCloseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/multiStyle_close_icon.eb44f17c.svg";
export { ForwardRef as ReactComponent };